module.exports = __webpack_public_path__ + "static/media/bg_07.112839fe.png";